module.exports = __webpack_public_path__ + "static/media/dp_placeholder.ae39fe9f.svg";